import { z } from "zod";
import { Temporal } from "@js-temporal/polyfill";
import { dateStr, id, instantDateTime, nullableText } from "./common";

export const rangeQuery = z
  .object({ from: dateStr, to: dateStr, venueId: id.optional() })
  .refine((r) => r.from <= r.to, { message: "from must be ≤ to", path: ["to"] });
export type RangeQuery = z.infer<typeof rangeQuery>;

export const availabilityQuery = z
  .object({ venueId: id, from: dateStr, to: dateStr, startUtc: instantDateTime.optional(), endUtc: instantDateTime.optional() })
  .refine((r) => r.from <= r.to, { message: "from must be ≤ to", path: ["to"] })
  .superRefine((r, ctx) => {
    if ((r.startUtc === undefined) !== (r.endUtc === undefined)) ctx.addIssue({ code: "custom", path: [r.startUtc === undefined ? "startUtc" : "endUtc"], message: "Supply both interval endpoints" });
    if (r.startUtc && r.endUtc && instantDateTime.safeParse(r.startUtc).success && instantDateTime.safeParse(r.endUtc).success && Temporal.Instant.compare(r.startUtc, r.endUtc) >= 0) ctx.addIssue({ code: "custom", path: ["endUtc"], message: "Interval end must be after its start" });
  });

export const blockKind = z.enum(["blocked", "maintenance"]);

export const blockCreate = z
  .object({
    venueId: id,
    startDate: dateStr,
    endDate: dateStr.optional(),
    kind: blockKind.default("blocked"),
    note: nullableText.optional(),
  })
  .transform((b) => ({ ...b, endDate: b.endDate ?? b.startDate }))
  .refine((b) => b.startDate <= b.endDate, { message: "startDate must be ≤ endDate", path: ["endDate"] });
export type BlockCreate = z.infer<typeof blockCreate>;
